import { Injectable } from '@angular/core';
import { PermissionType } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import {
  BUSINESS,
  BUSINESS_DESCRIPTION,
  DOMAIN_PROD_URL,
  PERM_TYPE
} from '../../constants/profile-selector/profile-selector-constants';
import {
  DashboardResponse,
  loginAndGetDashboardResponse
} from '../../models/login';
import {
  CompanyDescription,
  ProfileSelectorAEM,
  URL
} from '../../models/profile-selector/profile-selector-aem.interface';
import { ProfileSelectorAdapterHelperSupportService } from './profile-selector-adapter-helper-support.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileSelectorAdapterHelperService extends ProfileSelectorAdapterHelperSupportService {
  // eslint-disable-next-line complexity
  deconstructResponse(
    response: Partial<DashboardResponse> | loginAndGetDashboardResponse,
    aemResponse: ProfileSelectorAEM
  ): void {
    const {
      businessTitle,
      headerSubTitle,
      headerTitle,
      footerSubTitle,
      footerSubTitleWithoutTermsOfUse,
      personalTitle,
      permissionTypes,
      companyDescription,
      title,
      url,
      pageHeader,
      nuTravelEAMFlag
    } = aemResponse.profileSelector;
    const {
      firstName,
      lastName,
      crprtName,
      permType,
      program,
      crprtAgrmntTypeCode,
      crprtAgrmntId,
      pgmType,
      userId
    } = response;
    this.firstName = firstName;
    this.lastName = lastName;
    this.permType = permType?.split('|');
    this.program = program?.split('|') ?? '';
    this.companyName = crprtName?.split('|');
    this.crprtAgrmntTypeCode = crprtAgrmntTypeCode?.split('|') ?? '';
    this.crprtAgrmntId = crprtAgrmntId?.split('|') ?? '';
    this.pgmType = pgmType?.split('|') ?? '';
    this.permissionTypes = permissionTypes;
    this.businessTitle = businessTitle;
    this.personalTitle = personalTitle;
    this.headerTitle = headerTitle;
    this.footerSubTitle = footerSubTitle;
    this.footerSubTitleNoTerms = footerSubTitleWithoutTermsOfUse;
    this.headerSubTitle = headerSubTitle;
    this.companyDescription = companyDescription;
    this.title = title;
    this.url = url;
    this.deltaLogoUrl = pageHeader.logoUrl;
    this.altText = pageHeader.altText;
    this.userId = userId?.split('|') ?? '';
    this.nuTravelEAMFlag = nuTravelEAMFlag ?? 'true';
    this.setCorporateCode();
  }

  transformPageHeader(): void {
    this.pageHeader = {
      headerTitle: `${this.headerTitle}, ${this.firstName}`,
      headerSubTitle: this.headerSubTitle,
      altText: this.altText,
      logoUrl: this.deltaLogoUrl
    };
    this.profileSelectorPageFooter = {
      footerSubText: this.footerSubTitle,
      footerSubTextWithoutToU: this.footerSubTitleNoTerms
    };
  }

  transformPersonalProfileView(): void {
    this.personalProfileView = {
      title: this.personalTitle,
      displayName: `${this.firstName} ${this.lastName}`,
      firstName: this.firstName ?? '',
      selectedState: true
    };
  }

  setDefaultBusiness(): PermissionType {
    const defaultBusiness = {
      title: this.title.permType_B ?? BUSINESS,
      description: this.companyDescription.permType_B ?? BUSINESS_DESCRIPTION,
      urlToRedirect: this.url.permType_B ?? DOMAIN_PROD_URL,
      selectedState: false,
      permType: PERM_TYPE.B
    };
    return defaultBusiness;
  }

  adminLink(business: string, businessAccountIndex: number): void {
    const targetVal = business ? '_self' : '_blank';
    const userIdList = this.dashboardResponse.userId
      ? this.dashboardResponse.userId.split('|')
      : '';
    const adminLinkUrl = this.profileSelectorUtilService.getAdminUrl(
      this.url.nuTravelAdminLoginUrl,
      userIdList[businessAccountIndex]
    );
    window.open(adminLinkUrl, targetVal);
  }

  permissionListAdminAndSkyBonusPath(type: string): PermissionType[] {
    const defaultBusiness = this.setDefaultBusiness();
    const permissionTypeArray: PermissionType[] = [defaultBusiness];
    const typeArray = type.split(',');
    typeArray.reverse();
    typeArray.forEach((type) => {
      const readingFromAem = type ? `permType_${type}` : '';
      permissionTypeArray.push({
        title: this.title[readingFromAem as keyof CompanyDescription],
        description:
          this.companyDescription[readingFromAem as keyof CompanyDescription],
        urlToRedirect: this.url[readingFromAem as keyof URL],
        selectedState: false,
        permType: type
      });
    });
    return permissionTypeArray;
  }
}
